import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

const SECOND_LEVEL_COLLAPSED_KEY = 'isophi.sidebar.secondLevelCollapsed';

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(SECOND_LEVEL_COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  /** Set by pages that have no use for the second-level menu (e.g. the Portfolio dashboard). */
  readonly secondLevelMenuVisible$ = new BehaviorSubject(true);
  /** The user hid the second-level menu to get more room (remembered in this browser); the mobile menu ignores it. */
  readonly secondLevelCollapsed$ = new BehaviorSubject(readCollapsed());
  readonly openMenu$ = new ReplaySubject<void>();

  setSecondLevelCollapsed(collapsed: boolean): void {
    this.secondLevelCollapsed$.next(collapsed);
    try {
      localStorage.setItem(SECOND_LEVEL_COLLAPSED_KEY, collapsed ? '1' : '0');
    } catch {
      // storage unavailable (private mode): the choice lasts until reload
    }
  }
}
